module.exports = __webpack_public_path__ + "img/settings.2e125f18.svg";